import React, { useEffect, useState } from "react";
import { Card, Button, ProgressBar, Table, Collapse } from "react-bootstrap";

const PlayPage = () => {
  const [packages, setPackages] = useState([]);
  const [openDetails, setOpenDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  const username = user?.username;

  useEffect(() => {
    const fetchUserPackages = async () => {
      try {
        if (!username) {
          setError("Username not found in localStorage.");
          setLoading(false);
          return;
        }

        const response = await fetch(`https://api.backofficemain.com/get_user_packagesx.php?username=${username}`);
        const data = await response.json();

        if (data.success && Array.isArray(data.data)) {
          setPackages(data.data);
        } else {
          setError("There are no active packages for this user.");
        }
      } catch (err) {
        console.error("Fetch failed:", err);
        setError("Failed to fetch package data.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserPackages();
  }, [username]);

  const toggleDetails = (id) => {
    setOpenDetails((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // 🎥 Daftar ID video YouTube populer (untuk variasi thumbnail)
  const youtubeIds = [
    "dQw4w9WgXcQ", "9bZkp7q19f0", "kxopViU98Xo", "L_jWHffIx5E",
    "3JZ_D3ELwOQ", "2Vv-BfVoq4g", "OPf0YbXqDm0", "fLexgOxsZu0",
    "YQHsXMglC9A", "kXYiU_JCYtU", "6Dh-RL__uN4", "E07s5ZYygMg",
    "RgKAFK5djSk", "hT_nvWreIhg", "pRpeEdMmmQ0", "uelHwf8o7_U",
    "60ItHLz5WEA", "JGwWNGJdvx8", "SlPhMPnQ58k", "2vjPBrBU-TM",
    "8aShfolR6w8", "KQ6zr6kCPj8", "oRdxUFDoQe0", "3tmd-ClpJxA",
    "ktvTqknDobU", "ZbZSe6N_BXs", "xTlNMmZKwpA", "kJQP7kiw5Fk",
    "ScNNfyq3d_w", "e-ORhEE9VVg", "09R8_2nJtjg", "nfWlot6h_JM",
    "CevxZvSJLk8", "lp-EO5I60KA", "iS1g8G_njx8", "2Vv-BfVoq4g",
    "CduA0TULnow", "hLQl3WQQoQ0", "uelHwf8o7_U", "rYEDA3JcQqw",
    "oofSnsGkops", "lY2yjAdbvdQ", "Wch3gJG2GJ4", "hTWKbfoikeg",
    "fRh_vgS2dFE", "sOnqjkJTMaA", "hLQl3WQQoQ0", "tVj0ZTS4WF4",
    "bESGLojNYSo", "ktvTqknDobU", "NGLxoKOvzu4", "09R8_2nJtjg",
    "JGwWNGJdvx8", "y6120QOlsfU", "SlPhMPnQ58k", "RgKAFK5djSk",
    "kXYiU_JCYtU", "ZbZSe6N_BXs", "9bZkp7q19f0", "oRdxUFDoQe0"
  ];

  // ✅ Ambil 50 ID unik tanpa duplikat untuk setiap paket
  const getUniqueYoutubeIds = () => {
    const shuffled = [...youtubeIds].sort(() => Math.random() - 0.5);
    const unique50 = shuffled.slice(0, 50);
    return unique50.map((id) => `https://img.youtube.com/vi/${id}/0.jpg`);
  };

  if (loading)
    return <div className="text-center mt-5 text-secondary">Loading data...</div>;
  if (error)
    return <div className="text-center mt-5 text-danger">{error}</div>;
  if (!packages.length)
    return <div className="text-center mt-5 text-muted">There are no active packages.</div>;

  return (
    <div className="container py-3">
      <h4 className="mb-4 text-center text-danger">🎬 My Active Package</h4>

      {packages.map((pkg) => {
        const thumbnails = getUniqueYoutubeIds(); // unik untuk tiap package

        return (
          <Card className="mb-3 shadow-sm" key={pkg.transaction_id}>
            <Card.Body>
              <Card.Title className="text-danger fw-bold">{pkg.package_name}</Card.Title>
              <Card.Text>
                <strong>Price:</strong> ${pkg.price} <br />
                <strong>Profit Like:</strong> ${pkg.profit_like} |{" "}
                <strong>Profit View:</strong> ${pkg.profit_view}
              </Card.Text>

              <ProgressBar now={pkg.progress} label={`${pkg.progress}%`} className="mb-3" />

              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => toggleDetails(pkg.transaction_id)}
                aria-controls={`details-${pkg.transaction_id}`}
                aria-expanded={openDetails[pkg.transaction_id]}
              >
                {openDetails[pkg.transaction_id]
                  ? "Hide Details"
                  : "View Details"}
              </Button>

              <Collapse in={openDetails[pkg.transaction_id]}>
                <div id={`details-${pkg.transaction_id}`} className="mt-3">
                  <Table bordered hover size="sm" className="text-center align-middle">
                    <thead className="table-danger">
                      <tr>
                        <th>Video</th>
                        <th>Like</th>
                        <th>View</th>
                        <th>Profit</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from({ length: 50 }).map((_, i) => {
                        const completed = i < pkg.progress / 2;
                        const randomChoice = Math.random() < 0.5 ? "like" : "view";
                        const isLike = completed && randomChoice === "like";
                        const isView = completed && randomChoice === "view";

                        return (
                          <tr
                            key={i}
                            style={{
                              borderLeft: completed ? "5px solid #28a745" : "none",
                              backgroundColor: completed ? "#e9f9ee" : "transparent",
                            }}
                          >
                            <td>
                              <img
                                src={thumbnails[i]}
                                alt={`Video ${i + 1}`}
                                style={{ width: "120px", borderRadius: "6px" }}
                              />
                            </td>
                            <td>{isLike ? "✔️" : "❌"}</td>
                            <td>{isView ? "✔️" : "❌"}</td>
                            <td>${parseFloat(pkg.profit_like).toFixed(2)}</td>
                            <td
                              style={{
                                color: completed ? "green" : "orange",
                                fontWeight: "bold",
                              }}
                            >
                              {completed ? "Complete" : "Pending"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </Collapse>
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
};

export default PlayPage;
